import * as React from 'react';
import { useBeforeunload } from 'react-beforeunload';
/**
 * Финансовый компонент без тайпингов
 * state сохраняется в localStorage
 * при обновление страницы ломается верстка,
 * поэтому при на unmount компонента чистим
 * calculatorState в localStorage
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { CalculatorComponent } from '@finance/calculator-component';
import { LandingBlock } from '../../components/LandingBlock';
import { ContentWrapper } from '../../components/ContentWrapper';
import { BlockHeader } from '../../components/BlockHeader';
import * as styles from './SuburbanFinCalculator.css';
import { ISuburbanCalculatorData } from '../../types/suburban';

interface ISuburbanFinCalculator {
  config: ISuburbanCalculatorData;
}

export const FIN_CALCULATOR_STATE_STORAGE_KEY = 'calculatorState';

/* istanbul ignore next */
export const removeFinCalcStateFromLocalStorage = () => {
  localStorage.removeItem(FIN_CALCULATOR_STATE_STORAGE_KEY);
};

export const SuburbanFinCalculator: React.VFC<ISuburbanFinCalculator> = ({ config }) => {
  useBeforeunload(removeFinCalcStateFromLocalStorage);

  return (
    <div className={styles['fin-container']}>
      <LandingBlock>
        <ContentWrapper>
          <BlockHeader>Рассчитайте условия ипотеки</BlockHeader>
          <CalculatorComponent {...config} />
        </ContentWrapper>
      </LandingBlock>
    </div>
  );
};
